<script type="text/javascript">
import Vue from 'vue'
import _ from 'lodash'
import AskDelegateAboutSupplier from './AskDelegateAboutSupplier';

const minutesBeforeEndWhenMeetingStartsFinishing = 2

export default {
  name: 'AskDelegateAboutSupplierController',
  props: ['delegate', 'entries', 'currentEntry'],
  components: {AskDelegateAboutSupplier},
  created() {
    this.keepCheckingWhetherToAskDelegate()
  },
  methods: {
    keepCheckingWhetherToAskDelegate() {
      this.checkInterval = setInterval(this.checkWhetherToAskDelegate, 1000)
    },
    checkWhetherToAskDelegate() {
      let lastMeeting = this.lastMeeting()

      if (
        this.delegateIsNotBeingAlreadyAsked() &&
        !!lastMeeting &&
        this.delegateClickedToJoinMeeting(lastMeeting) &&
        this.delegateHasntBeenAskedAboutMeeting(lastMeeting) &&
        this.delegateHasntAnsweredAboutMeeting(lastMeeting) &&
        this.meetingIsFinishingOrFinished(lastMeeting) &&
        (lastMeeting == this.currentEntry || !this.currentEntry)
      ) {
        this.askQuestionAboutMeeting(lastMeeting)
      }
    },
    lastMeeting() {
      return _.find(this.entries, (entry) => {
        return new Date(entry.starts_at) <= this.$store.state.currentTime && entry.type == 'meeting'
      })
    },
    askQuestionAboutMeeting(meeting) {
      localStorage[`delegate_has_been_asked_about_supplier_${meeting.supplier_id}`] = "true"
      this.askQuestionView = new (Vue.extend(AskDelegateAboutSupplier))({
        propsData: {
          delegate: this.attendee,
          meeting: meeting
        }
      })
    },
    delegateIsNotBeingAlreadyAsked() {
      return !this.askQuestionView || this.askQuestionView._isDestroyed;
    },
    delegateHasntBeenAskedAboutMeeting(meeting) {
      return !localStorage[`delegate_has_been_asked_about_supplier_${meeting.supplier_id}`]
    },
    delegateHasntAnsweredAboutMeeting(meeting) {
      return !meeting.answered_about_doing_business_with_supplier;
    },
    meetingIsFinishingOrFinished(meeting) {
      let meetingStartsFinishingAt = new Date(new Date(meeting.ends_at) - minutesBeforeEndWhenMeetingStartsFinishing * 60 * 1000)
      return meetingStartsFinishingAt < this.$store.state.currentTime
    },
    delegateClickedToJoinMeeting(meeting) {
      return meeting.clicked_to_join
    }
  },
  beforeDestroy () {
    clearInterval(this.checkInterval)
  }
}
</script>

